<div class="flex justify-center">
  <rd-shared-spinner></rd-shared-spinner>
</div>
<div class="processing-text">{{ 'fulfillment.processing' | translate }}</div>
<div class="wait-disclaimer-text">
  {{ 'fulfillment.wait_disclaimer' | translate }}
</div>
